import ApplicationController from './application_controller'

/*
 * Important : Les champs appartenant aux deux catégories,
 * "individual" + "professional" ne doivent pas être ajoutés aux targets.
 */
export default class extends ApplicationController {
  static targets = ["individualFields", "professionalFields", "individualRadio", "professionalRadio"]

  connect() {
    this.updateFieldsVisibility()
  }

  toggle() {
    this.updateFieldsVisibility()
  }

  updateFieldsVisibility() {
    const isProfessional = this.professionalRadioTarget.checked
    
    this.professionalFieldsTargets.forEach((item) => {
      if (isProfessional) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}